import { VIDEO_PLAYER_MODAL_MODULE } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[VIDEO_PLAYER_MODAL_MODULE]: {
		moduleType: 'modal',
		modalContent: {},
	},
}
